query students($teamId: ID, $limit: Int, $search: String) {
  students(team_id: $teamId, limit: $limit, search: $search) {
    id
    first
    last
    positivity
    mostRecentCommunication
    communicationCount
    gradeLevel {
      id
      name
      order
    }
  }
}
